import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Banner = ({ children, color }) => (
  <div
    className={classNames('p-1', {
      'bg-orange-50 border-0 border-b-2 border-solid border-orange-600 bg-opacity-70': color === 'orange',
    })}
  >
    { children }
  </div>
);

Banner.defaultProps = {
  color: null,
};

Banner.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf([
    'orange',
  ]),
};

export default Banner;
